// Whether this page load has held a signed-in session. Lives for the document
// and is never cleared by sign-out: App keeps per-session state (Nitro, the
// completed bootstrap phases) above the router, and only a new document drops it.
let documentAuthenticated = false;

export const markDocumentAuthenticated = () => {
  documentAuthenticated = true;
};

export const hasDocumentBeenAuthenticated = () => documentAuthenticated;

export const resetDocumentAuthHistoryForTests = () => {
  documentAuthenticated = false;
};
